import VarietySelect from './VarietySelect';

export default VarietySelect;
